import React, { useState, useEffect } from "react";
import {
  GetSubscriptionDetails,
  deleteUserSubscription,
} from "../services/PaymentService";
import { useAxiosInstance } from "../services/Interceptor";
import { ModalUpdateIntelliPay } from "./ModalUpdateIntelliPay";
import { useParams, useNavigate } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { toast } from "react-toastify";

const CardDetails = ({ account, email }) => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiInstance = useAxiosInstance();
  const { userId } = useParams();
  const { user } = useAuthUser();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await GetSubscriptionDetails(apiInstance);
        setSubscription(res.data);
      } catch (err) {
        console.error("Error loading subscription details", err);
      }
    };
    fetchDetails();
  }, [apiInstance]);

  const handleCancelSubscription = async () => {
    try {
      setLoading(true);
      await deleteUserSubscription(apiInstance);
      toast.success("Subscription cancelled successfully.");
      setSubscription(null);
      const redirectPath =
        user.role === "university" ? "/university/account" : "/athlete/account";

      navigate(redirectPath);
    } catch (err) {
      console.error("Error cancelling subscription", err);
      toast.error("Failed to cancel subscription.");
    } finally {
      setLoading(false);
    }
  };

  if (!subscription) return null;

  return (
    <div className="bg-white shadow-lg p-4 rounded-lg">
      <h2 className="text-xl mb-4 uppercase">Card Information</h2>

      <div className="mt-4">
        <label>Card Number:</label>
        <input
          className="w-full p-2 border bg-gray-100 rounded"
          value={
            subscription.last4Digits
              ? "************" + subscription.last4Digits
              : ""
          }
          readOnly
        />
      </div>

      <div className="flex gap-4 mt-4">
        <div className="w-1/2">
          <label>Exp Month</label>
          <input
            className="w-full p-2 border bg-gray-100 rounded"
            value={subscription.expMonth}
            readOnly
          />
        </div>
        <div className="w-1/2">
          <label>Exp Year</label>
          <input
            className="w-full p-2 border bg-gray-100 rounded"
            value={subscription.expYear}
            readOnly
          />
        </div>
      </div>

      <div className="flex justify-between mt-6">
        <button
          onClick={handleCancelSubscription}
          disabled={loading}
          className="bg-blue-600 text-white uppercase rounded-md px-6 py-2 text-center hover:bg-blue-800 cursor-pointer mt-2"
        >
          {loading ? "Cancelling..." : "Cancel Subscription"}
        </button>

        <a
          className="bg-red-500 text-white px-4 py-2 rounded-md uppercase hover:bg-red-700 mt-4 ml-3"
          href={`/${user.role === "athlete" ? "athlete" : "university"}/account/${account}`}
        >
          Update
        </a>
      </div>

      {userId !== undefined && <ModalUpdateIntelliPay />}
    </div>
  );
};

export default CardDetails;
